import type { DataBindingComponentModel } from '@wix/data-binding-registry-sdk'
import { FieldType } from '@wix/wix-data-schema-types'

export const textMask: DataBindingComponentModel = {
  panel: {
    height: 212,
    title: 'Connect_Panel_Title_TextMask',
    helpId: '25bbe5dc-7259-4f61-a7fc-5deb7d8cc83f',
  },
  componentName: 'TextMask_db_comp_name',
  sections: [
    {
      role: 'TextMaskRole',
      bindings: [
        {
          title: 'Connect_Panel_Connect_TextMask_Label',
          prop: 'text',
          supportedFieldTypes: [
            FieldType.text,
            FieldType.email,
            FieldType.number,
            FieldType.dateTime,
            FieldType.time,
            FieldType.url,
            FieldType.address,
            FieldType.richText,
          ],
          defaultFieldType: FieldType.text,
          requiresPrimaryConnection: true,
        },
      ],
      manifest: {
        gfpp: {
          desktop: {
            mainAction1: {
              actionId: 'gfpp_edit_text',
              label: 'TextMask_db_edit_text_label',
            },
          },
        },
      },
      manageContentPanel: {
        description: 'TextMask_db_manage_content',
      },
    },
  ],
  compactErrorPanel: true,
}
